import { trackAnalytics } from "services/analytics";

export const faOnFeedbackPageLoad = (feedbackId, isAuth) => {
	trackAnalytics({
		eVar0: `b2b|${isAuth ? 'selfcare|': ''}feedback`,
		prop33: feedbackId,
	});
};

export const faOnFeedbackSubmit = ({rating, reasons, comment, isAuth}) => {
  trackAnalytics({
    eVar9: `b2b|${isAuth ? 'selfcare|': ''}feedback|feedback submitted`,
	prop3: rating,
	prop42: reasons,
	eVar39: comment,
  });
};

export const faOnFeedbackSubmitReset = () => {
  trackAnalytics({
	prop3: '',
	prop42: '',
	eVar39: '',
  });
};

export const faOnFeedbackSubmittedPopupLoad = ({isAuth}) => {
	trackAnalytics({
	  eVar0: `b2b|${isAuth ? 'selfcare|': ''}feedback|feedback submitted`,
	});
  };